import Vue from "vue";
if (document.getElementById("recover-password")) {
  var recoverPassword = new Vue({
    el: "#recover-password",
    data: {
      test: "efef",
      login: ""
    },
    mounted() {
      if (window.localStorage.getItem("login")) {
        this.login = window.localStorage.getItem("login");
      }
    },
    methods: {
      delStorageLogin() {
        window.localStorage.removeItem("login");
      }
    }
  });
}
